import { useState } from 'react'
import {
  TeamStatisticsSection,
  huntingYearWindow,
  type StatisticsPeriod,
} from '@wehunt/ui'
import { useGameNamesCatalog } from '../hunts/plan/useGameNamesCatalog'
import { useTeamGameReportStats } from './useTeamGameReportStats'

/** Initial period: the current hunting year (Jul 1 → Jun 30). */
function defaultPeriod(): StatisticsPeriod {
  const { from, to } = huntingYearWindow(new Date())
  return { from: from.toISOString(), to: to.toISOString() }
}

/**
 * Data-connected Statistics surface for a team. Owns the selected period, fetches
 * the aggregated game-report stats for it, and supplies the live game-name
 * catalog so species render with localized display names. Presentation lives in
 * `@wehunt/ui`'s `TeamStatisticsSection`; this container holds all the wiring.
 */
export function TeamStatisticsContainer({ groupId }: { groupId: string }) {
  const [period, setPeriod] = useState<StatisticsPeriod>(defaultPeriod)
  const { data, isLoading } = useTeamGameReportStats(groupId, period.from, period.to)
  const { catalog } = useGameNamesCatalog()
  return (
    <TeamStatisticsSection
      data={data}
      loading={isLoading}
      period={period}
      onPeriodChange={setPeriod}
      speciesCatalog={catalog}
    />
  )
}
